<template>
  <div class="goods">
    <div class="nav">
      <div class="w">
        <el-dropdown @command="changeValue">
          <span class="el-dropdown-link">
            品牌<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in brandOptions" :key="item.value" :command="item.value" >{{ item.label }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="price-interval">
          <input type="number" class="input" placeholder="价格" v-model="min">
          <span style="margin: 0 5px"> - </span>
          <input type="number" placeholder="价格" v-model="max">
          <y-button text="确定" classStyle="main-btn" @btnClick="reset"  size="mini"></y-button>
        </div>
      </div>
    </div>

    <div v-loading="loading" element-loading-text="加载中..." class="img-item" v-if="goods != ''">
      <!--商品-->
      <div class="goods-box w">
        <mall-goods v-for="(item,i) in goods" :key="i" :msg="item"></mall-goods>
      </div>
      <div style="text-align: center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[8, 20, 40, 80]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <div v-loading="loading" element-loading-text="加载中..." class="no-info" v-else-if="goods == ''">
      <div class="no-data">
        <img src="/static/images/no-search.png">
        <br> 抱歉！没有为您找到相关的商品
      </div>
    </div>
    <div v-else>
      <div class="no-data">
        <img src="/static/images/error.png">
        <br> 抱歉！出错了...
      </div>
    </div>
  </div>
</template>
<script>
  import mallGoods from '../../../components/MallGoods/mallGoods'
  import YButton from '../../../components/YButton/YButton'
  import YShelf from '../../../components/Shelf/shelf'
  import { fetchSaleList } from '@/api/product'
  import {fetchList as fetchBrandList} from '@/api/brand'
  export default {
    data () {
      return {
        goods: [],
        min: null,
        max: null,
        loading: true,
        timer: null,
        sortType: 1,
        windowHeight: null,
        windowWidth: null,
        sort: '',
        currentPage: 1,
        total: 0,
        pageSize: 20,
        productName: null,
        shelves: 1,
        productSn: null,
        brandId: null,
        brandOptions: [],
        recommend: []
      }
    },
    methods: {
      handleSizeChange (val) {
        this.pageSize = val
        this._getAllGoods()
        this.loading = true
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this._getAllGoods()
        this.loading = true
      },
      getBrandName(id) {
        for (let i = 0; i < this.brandOptions.length; i++) {
          let b = this.brandOptions[i];
          if (b.value === id) {
            return b.label;
          }
        }
      },
      getBrandList() {
        fetchBrandList({pageNum: 1, pageSize: 900}).then(response => {
          this.brandOptions = [];
          let brandList = response.data;
          for (let i = 0; i < brandList.length; i++) {
            this.brandOptions.push({label: brandList[i].brandName, value: brandList[i].id});
          }
        });
      },
      _getAllGoods () {
        let params = {
          productName: this.productName,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          shelves: this.shelves,
          productSn: this.productSn,
          brandId: this.brandId,
          salesStartPrice: this.min,
          salesEndPrice: this.max
        }
        fetchSaleList(params).then(response => {
          this.loading = false;
          let ret = response.data;
          if (ret.length > 0) {
            for (let i in ret) {
              ret[i].brandName = this.getBrandName(ret[i].brandId)
            }
            this.goods = ret;
          }
          this.total = response.total;
        });
      },
      // 默认排序
      reset () {
        this.currentPage = 1
        this.loading = true
        this._getAllGoods()
      },
      // 价格排序
      changeValue (v) {
        this.brandId = v
        this.currentPage = 1
        this.loading = true
        this._getAllGoods()
      }
    },
    created () {

      this.getBrandList()
      this.productName = this.$route.query.key;
      this._getAllGoods()
    },
    mounted () {
      this.windowHeight = window.innerHeight
      this.windowWidth = window.innerWidth

    },
    components: {
      mallGoods,
      YButton,
      YShelf
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../../../assets/style/mixin";
  @import "../../../assets/style/theme";
  .el-dropdown-menu {
    overflow: scroll; // 添加滚动条
    max-height: 200px; // 最大高度
    overflow-x: hidden; // 隐藏x轴上的滚动条
  }

  .nav {
    height: 60px;
    line-height: 60px;
    > div {
      display: flex;
      align-items: center;
      a {
        padding: 0 15px;
        height: 100%;
        @extend %block-center;
        font-size: 12px;
        color: #999;
        &.active {
          color: #5683EA;
        }
        &:hover {
          color: #5683EA;
        }
      }
      input {
        @include wh(80px, 30px);
        border: 1px solid #ccc;
      }
      input + input {
        margin-left: 10px;
      }
    }
    .price-interval {
      padding: 0 0px;
      @extend %block-center;
      input[type=number] {
        border: 1px solid #ccc;
        text-align: center;
        background: none;
        border-radius: 5px;
      }
    }
  }

  .goods-box {
    > div {
      float: left;
      border: 1px solid #efefef;
    }
  }

  .no-info {
    padding: 100px 0;
    text-align: center;
    font-size: 30px;
    display: flex;
    flex-direction: column;
    .no-data{
      align-self: center;
    }
  }

  .img-item{
    display: flex;
    flex-direction: column;
  }

  .el-pagination{
    align-self: flex-end;
    margin: 3vw 10vw 2vw;
  }

  .section {
    padding-top: 8vw;
    margin-bottom: -5vw;
    width: 1218px;
    align-self: center;
  }

  .recommend {
    display: flex;
    > div {
      flex: 1;
      width: 25%;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #5683EA;
    font-size: 12px;
    padding: 0 15px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/views/tourist/goods/goods.vue